import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

export default function GoToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      data-testid="go-to-top-btn"
      onClick={scrollToTop}
      aria-label="Върни се нагоре"
      style={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        width: 52,
        height: 52,
        borderRadius: "50%",
        backgroundColor: "#2dcf0c",
        border: "none",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 16px rgba(45,207,12,0.45)",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0) scale(1)" : "translateY(12px) scale(0.85)",
        transition: "opacity 0.3s ease, transform 0.3s ease, box-shadow 0.2s ease",
        pointerEvents: visible ? "auto" : "none",
        zIndex: 97,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(0) scale(1.1)";
        e.currentTarget.style.boxShadow = "0 6px 22px rgba(45,207,12,0.65)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0) scale(1)";
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(45,207,12,0.45)";
      }}
    >
      <ChevronUp size={24} color="#FFFFFF" strokeWidth={2.5} />
    </button>
  );
}
